function getTranslations() {
    // placeholder — wire up i18n API here
}

export default getTranslations;
